import gql from 'graphql-tag';

export default gql`
query getPdfDataByProjectid($projectId: Int!) {
  projects(where: {project_id: {_eq: $projectId}}) {
    pdf_export_url
    pdf_exported_at
    pdf_export_status
    pdf_render_mode
    pdf_page_size
    published
    editor_version
    group {
      settings
    }
    plugins(where: {handle: {_eq: "plugin_password_protection"}, enabled: {_eq: true}}) {
      enabled
      handle
    }
    # A password on a folder above protects the project too (founder 2026-10-06).
    # Folders nest at most 5 deep above a project (live 2026-10-06); 6 leaves room.
    parent_folder {
      ...PasswordFolder
      parent_folder {
        ...PasswordFolder
        parent_folder {
          ...PasswordFolder
          parent_folder {
            ...PasswordFolder
            parent_folder {
              ...PasswordFolder
              parent_folder {
                ...PasswordFolder
              }
            }
          }
        }
      }
    }
  }
}

fragment PasswordFolder on folders {
  name
  plugins(where: {handle: {_eq: "plugin_password_protection"}, enabled: {_eq: true}}) {
    enabled
  }
}
`;
